import dayjs from "dayjs";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";

dayjs.extend(isSameOrBefore);

type PaymentPeriod = {
  periodStart: string | Date;
};

// A period is outstanding when it is unsettled and either already due (its period has
// started) or the subscription has never had a settled period. The "has started" test
// alone would silently hide a future-dated package's never-paid first period, so a
// package that has collected nothing keeps warning until it does. Mirrors the
// server's getOutstandingSubscriptionPeriods; `isSettled` says whose payment counts.
export function getOutstandingSubscriptionPeriods<T extends PaymentPeriod>(
  periods: T[],
  isSettled: (period: T) => boolean,
): T[] {
  const hasAnySettledPeriod = periods.some((period) => isSettled(period));
  return periods.filter(
    (period) =>
      !isSettled(period) &&
      (!hasAnySettledPeriod ||
        dayjs(period.periodStart).isSameOrBefore(dayjs(), "day")),
  );
}
